import { render, staticRenderFns } from "./NoshiIcon.vue?vue&type=template&id=56640fc0&"
import script from "./NoshiIcon.vue?vue&type=script&lang=js&"
export * from "./NoshiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports